import ComponentRenderer from '@components/cms-components/component-renderer';
import ContactInfo from '@components/contact-info';
import { Madi, Yeseva } from 'app/fonts';
import type { ReactElement } from 'react';
import React from 'react';
import type { ContactInfoData } from 'types/components/contact-info';
import type { DataProps } from 'types/props/data-props';
import type SiteContext from 'types/site-context';

interface Props extends DataProps<ContactInfoData> {
  readonly context: SiteContext;
}

export default function ContactInfoComponent({
  context,
  description,
  eyebrow,
  heading,
  subHeading,
}: Props): ReactElement {
  return (
    <ContactInfo
      businessName={context.siteSettings.title}
      contactInformation={context.contactInformation}
      description={
        <ComponentRenderer context={context}>{description}</ComponentRenderer>
      }
      eyebrow={eyebrow}
      heading={<h1 className={Yeseva.className}>{heading}</h1>}
      subHeading={
        <p className={Madi.className} style={{ fontSize: '2.65rem' }}>
          {subHeading}
        </p>
      }
    />
  );
}
